import React from 'react';

import {yupResolver} from '@hookform/resolvers/yup';
import Grid from '@material-ui/core/Grid';
import {useStore} from 'effector-react';
import {useForm, Controller} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import * as yup from 'yup';

import {fetchStorages} from 'api';
import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {AsyncSelect} from 'components/ui-kit/Select';
import {
    stepChanged,
    aggregationFormChanged,
    aggregationForm$,
} from 'models/documents/create/aggregation';
import {AggregationFormData} from 'types';

import {FormWrapper, NavigationButtonsContainer, FormField, FormContainer} from '../common/styled';

const schema = yup.object().shape({
    storageLocationId: yup
        .number()
        .typeError('components.form.required')
        .required('components.form.required'),
});

export const DocumentForm = () => {
    const {t} = useTranslation();
    const aggregationForm = useStore(aggregationForm$);
    const {control, handleSubmit, formState, setValue, getValues} = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            ...aggregationForm,
        },
    });

    const loadOptions = async () =>
        (await fetchStorages()).storageLocations.map((value) => ({
            value: value.id,
            label: value.storageName,
            meta: {name: value.storageName ?? ''},
        }));

    const onHandleChanged = (data: AggregationFormData) => {
        aggregationFormChanged(data);
        stepChanged(1);
    };
    return (
        <FormContainer>
            <form onSubmit={handleSubmit(onHandleChanged)}>
                <FormWrapper>
                    <Grid container>
                        <Grid item xs={12} md={4}>
                            <FormField>
                                <Controller
                                    control={control}
                                    name="storageLocationId"
                                    render={({value, onChange}, {invalid}) => (
                                        <AsyncSelect
                                            key="storageLocationId"
                                            label={t('pages.documents.form.storageLocationName')}
                                            isClearable
                                            defaultOptions
                                            value={{
                                                value,
                                                label: value
                                                    ? getValues(`storageLocationName`) ||
                                                      aggregationForm?.storageLocationName
                                                    : value,
                                            }}
                                            onChange={(val: {
                                                value: number;
                                                meta?: {name: string};
                                            }) => {
                                                val ? onChange(val.value) : onChange(null);
                                                setValue?.(`storageLocationName`, val?.meta?.name);
                                            }}
                                            loadOptions={loadOptions}
                                            hasError={invalid}
                                        />
                                    )}
                                />
                                {formState.errors.storageLocationId?.message && (
                                    <span style={{fontSize: 12, color: 'red'}}>
                                        {t(formState.errors.storageLocationId?.message)}
                                    </span>
                                )}
                                <div style={{display: 'none'}}>
                                    <Controller
                                        control={control}
                                        name="storageLocationName"
                                        render={(props) => <input value={props.value} readOnly />}
                                    />
                                </div>
                            </FormField>
                        </Grid>
                    </Grid>
                </FormWrapper>
                <NavigationButtonsContainer>
                    <span />
                    <Button
                        style={{width: 'auto'}}
                        variant={ButtonVariant.Normal}
                        type="submit"
                        disabled={formState.isValid === false}
                    >
                        {t('components.form.nextStep')}
                    </Button>
                </NavigationButtonsContainer>
            </form>
        </FormContainer>
    );
};
